<div id="dsbutton" >
    <div class="dspopupHoverElement" >
        <input [(ngModel)]="inputdata" class="text-size-12 background-white text-dark w100 nm" name="" [placeholder]="translate('Artikel zoeken')"
            title="Artikel zoeken" type="text" (keyup)="onkeypress($event)" (focusin)="onenter()" (focusout)="onleaveinput()">
    </div>
    <div id="dspopupboxh" class="dspopupBox"  tabindex="101" (blur)="onleave()">
        <app-searchbarpopup (onClicked)="click()" [FoundResults]="FoundResults" [ExactResults]="ExactResults"></app-searchbarpopup>
    </div>
</div>